module.exports = __webpack_public_path__ + "44d45a32f9f294e9fbb687ca8d3e43f3.pdf";